import React, { useCallback } from "react";
import { SanityCallToActionButton } from "../../model/common";
import Button from "../Button/StandardButton/Button";
import { triggerModal } from "../PageModal/PageModal";

const ModalTriggerButton = ({
  targetModal,
  primary,
  title
}: SanityCallToActionButton) => {
  const handleClick = useCallback(() => {
    if (targetModal) {
      triggerModal(targetModal);
    }
  }, [targetModal]);
  return (
    <Button onClick={handleClick} primary={primary}>
      {title}
    </Button>
  );
};

export default ModalTriggerButton;
